var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ios",
    transform: "translate(-153 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10675",
    "data-name": "Rectangle 10675",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(153 579)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(162.78 585.747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M45.568,3.837A4.9,4.9,0,0,0,46.985,0a6.4,6.4,0,0,0-4.01,1.82,4.7,4.7,0,0,0-1.446,3.72A5.339,5.339,0,0,0,45.568,3.837Zm2.915,9.724a5.656,5.656,0,0,1,2.611-4.746,5.591,5.591,0,0,0-4.424-2.47c-1.885-.2-3.675,1.142-4.632,1.142S39.61,6.371,38.047,6.4a5.9,5.9,0,0,0-5,3.127C30.907,13.344,32.5,19,34.576,22.092c1.017,1.515,2.228,3.215,3.818,3.154,1.535-.061,2.114-1.021,3.965-1.021s2.371,1.021,3.992.99c1.649-.031,2.693-1.544,3.7-3.064a13.935,13.935,0,0,0,1.675-3.545A5.492,5.492,0,0,1,48.482,13.561Z",
    transform: "translate(-32.029 0)",
    fill: "#9ba6ac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.cca788dc.svg";
export { ForwardRef as ReactComponent };